import script from "./coupon-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./coupon-bar.vue?vue&type=script&setup=true&lang=js"

import "./coupon-bar.vue?vue&type=style&index=0&id=351aa1bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351aa1bc"]])

export default __exports__